import { type ChangeEvent, useId } from 'react';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

export default function SurveyNotesField({
    value,
    onChange,
}: {
    value: string;
    onChange: (value: string) => void;
}) {
    const id = useId();

    return (
        <div className="space-y-2">
            <Label htmlFor={id}>Observações gerais (opcional)</Label>
            <Textarea
                id={id}
                value={value}
                onChange={(event: ChangeEvent<HTMLTextAreaElement>) => onChange(event.target.value)}
                placeholder="Inclua nuances clínicas ou contexto relevante que complementem a observação."
                className="min-h-[120px]"
            />
        </div>
    );
}
